import React from 'react';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { getServicedeskPageContextResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { servicedeskCmdbAssetsDashboardsDetailRoute } from '@atlassian/jira-router-routes-servicedesk-cmdb-routes/src/servicedeskCmdbAssetsDashboardsDetailRoute.tsx';
import { workspaceResource } from '@atlassian/jira-servicedesk-insight-common-workspace-context/src/services/resources/index.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { Redirect } from '@atlassian/react-resource-router';
import { isNewReportsNavExperienceEnabled } from '@atlassian/jira-insight-reports-v2/src/common/feature-gate-helpers.tsx';
import { DashboardEditable } from '@atlassian/jira-insight-reports-v2/src/ui/dashboard-editable/index.tsx';
import { AssetsAppBase } from '@atlassian/jira-spa-assets-app-base/src/ui/index.tsx';
import { APP_NAMES } from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';

const DashboardsDetailPage = () => (
	<AssetsAppBase appName={APP_NAMES.INSIGHT_ASSETS_REPORTS}>
		{({ workspaceId }) => <DashboardEditable workspaceId={workspaceId} />}
	</AssetsAppBase>
);

export const servicedeskCmdbAssetsDashboardsDetailRouteEntry = createEntry(
	servicedeskCmdbAssetsDashboardsDetailRoute,
	() => ({
		group: 'servicedesk',
		layout: globalLayout,
		navigation: { menuId: MENU_ID.INSIGHT },
		component: isNewReportsNavExperienceEnabled()
			? DashboardsDetailPage
			: () => <Redirect to="/jira/servicedesk/assets/reports" />,
		resources: [
			...getNavigationResources(),
			...getServicedeskPageContextResources(),
			workspaceResource,
		],
		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
			bundling: {
				packageName:
					'@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbAssetsDashboardsDetailRouteEntry.tsx',
				whichExportToUse: 'servicedeskCmdbAssetsDashboardsDetailRouteEntry',
			},
			enabled: true,
		},
	}),
);
